import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import SearchIcon from '@mui/icons-material/Search';
import PsychologyIcon from '@mui/icons-material/Psychology';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BrushIcon from '@mui/icons-material/Brush';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import SpeedIcon from '@mui/icons-material/Speed';
import './UIUXProcess.css';

const processes = [
  {
    icon: <SearchIcon sx={{ fontSize: 32 }} />,
    title: 'Research & Discovery',
    description: 'Understanding user needs, business goals, and market analysis through comprehensive research.',
    gradient: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%)',
    delay: 0.2
  },
  {
    icon: <PsychologyIcon sx={{ fontSize: 32 }} />,
    title: 'User Analysis',
    description: 'Creating user personas, journey maps, and identifying pain points to inform design decisions.',
    gradient: 'linear-gradient(135deg, #4ECDC4 0%, #2BAE85 100%)',
    delay: 0.3
  },
  {
    icon: <AccountTreeIcon sx={{ fontSize: 32 }} />,
    title: 'Information Architecture',
    description: 'Organizing content structure, user flows, and navigation patterns for optimal user experience.',
    gradient: 'linear-gradient(135deg, #45B7D1 0%, #2E97B7 100%)',
    delay: 0.4
  },
  {
    icon: <BrushIcon sx={{ fontSize: 32 }} />,
    title: 'UI Design',
    description: 'Creating visually stunning interfaces with attention to color, typography, and visual hierarchy.',
    gradient: 'linear-gradient(135deg, #96CEB4 0%, #6BAF96 100%)',
    delay: 0.5
  },
  {
    icon: <ViewInArIcon sx={{ fontSize: 32 }} />,
    title: 'Prototyping',
    description: 'Building interactive prototypes to test user flows and interactions before development.',
    gradient: 'linear-gradient(135deg, #4B7BE5 0%, #3153B0 100%)',
    delay: 0.6
  },
  {
    icon: <SpeedIcon sx={{ fontSize: 32 }} />,
    title: 'Testing & Iteration',
    description: 'Conducting user testing, gathering feedback, and iterating designs for optimal results.',
    gradient: 'linear-gradient(135deg, #6C63FF 0%, #4B44CC 100%)',
    delay: 0.7
  }
];

const UIUXProcess = () => {
  return (
    <section className="uiux-process">
      <div className="uiux-process-bg-circle"></div>
      <div className="uiux-process-bg-circle-2"></div>
      
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="uiux-process-header"
        >
          <Typography variant="h2" className="uiux-process-title">
            Our Design Process
          </Typography>
          <Typography variant="subtitle1" className="uiux-process-subtitle">
            A systematic approach to creating exceptional user experiences
          </Typography>
        </motion.div>

        <div className="uiux-timeline">
          {/* <div className="uiux-timeline-progress"></div> */}
          {processes.map((process, index) => (
            <motion.div
              key={index}
              className="uiux-timeline-item"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: process.delay }}
            >
              <div className="uiux-timeline-content">
                <div 
                  className="uiux-timeline-icon"
                  style={{ background: process.gradient }}
                >
                  {process.icon}
                  <div className="uiux-timeline-dot"></div>
                </div>
                <Typography variant="h6" className="uiux-timeline-title">
                  {process.title}
                </Typography>
                <Typography className="uiux-timeline-description">
                  {process.description}
                </Typography>
                <div className="uiux-timeline-step">
                  {(index + 1).toString().padStart(2, '0')}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default UIUXProcess; 